export default "__VITE_ASSET__NKB1oJ_n__"